<template>
  <layout-main-inner title="快检标准">
    <layout-card-wrap hasSlot>
      <template slot="form">
        <el-input
          v-model="config.samplename"
          clearable
          placeholder="请输入样品名称"
          @clear="handleCurrentChange(1)"
        >
          <el-button
            slot="append"
            icon="el-icon-search"
            @click="handleCurrentChange(1)"
          ></el-button>
        </el-input>
      </template>
      <el-table
        border
        :span-method="arraySpanMethod"
        :data="list">
        <el-table-column
          label="样品名称"
          min-width="180"
          prop="samplename">
        </el-table-column>
        <el-table-column
          label="检测项数量"
          width="100"
          :formatter="(row)=> row.testprojectCount + '项'"
          prop="testprojectCount">
        </el-table-column>
        <el-table-column
          label="检测项"
          width="250"
          class-name="class-name"
          prop="testprojectCount">
          <template slot-scope="{ row }">
            <!-- {{ row.testprojectCount }} -->
            <el-table
              class="table-inner"
              :show-header="false"
              :data="row.details">
              <el-table-column
                label="检测项"
                width="249"
                prop="testproject"
              ></el-table-column>
              <el-table-column
                label="判定标准"
                width="220"
                prop="standnum"
              ></el-table-column>
              <el-table-column
                width="140"
                label="判定值">
                <template slot-scope="scope">
                  {{ scope.row.symbol }}{{ scope.row.cov }}{{ scope.row.covunit }}
                </template>
              </el-table-column>
            </el-table>
          </template>
        </el-table-column>
        <el-table-column
          label="判定标准"
          width="220"
          prop="testprojectCount">
        </el-table-column>
        <el-table-column
          label="判定值"
          width="140"
          prop="testprojectCount">
        </el-table-column>
      </el-table>
      <el-pagination
        slot="footer"
        background
        :current-page.sync="config.pageNum"
        :page-size="config.pageSize"
        layout="total, prev, pager, next"
        :total="totalNum"
        @current-change="handleCurrentChange"
      >
      </el-pagination>
    </layout-card-wrap>
    <standard-modal ref="standard" />
  </layout-main-inner>
</template>
<script>
import { mapState } from 'vuex'
import StandardModal from './busi/standard-modal.vue'
export default {
  name: 'InspectionStandard',
  components: { StandardModal },
  data() {
    return {
      loading: true,
      list: [],
      totalNum: 0,
      config: {
        pageNum: 1,
        pageSize: 10,
        samplename: null
      }
    }
  },
  computed: {
    ...mapState({
      userInfo: (state) => state.account.userInfo,
      permission: (state) => state.account.permission
    })
  },
  mounted() {
    this.getlist()
  },
  methods: {
    arraySpanMethod({ columnIndex }) {
      if (columnIndex > 1) {
        if (columnIndex === 2) {
          return [1, 3]
        } else {
          return [1, 1]
        }
      }
    },
    viewStandard(row) {
      this.$refs.standard.init(row.samplename)
    },
    handleCurrentChange(val) {
      this.config.pageNum = val
      this.getlist()
    },
    getlist() {
      this.loading = true
      this.$store.dispatch('account/getinspectionstandardsums', {
        payload: this.config,
        success: (res) => {
          this.loading = false
          this.totalNum = res.data.total
          this.list = res.data.records
        },
        fail: () => {
          this.loading = false
        }
      })
    }
  }
}
</script>
<style lang="stylus">
.table-inner {
  &.el-table::before{
    height 0
  }
   tr:last-child td {
     border-bottom none
   }
  td {
    border-right: none;
  }
}
.class-name >.cell {
  padding 0
}
</style>
